// extracted by mini-css-extract-plugin
export default {"rating":"rating_rating__yLf2I"};